import { ThoughtBubbleOutlineIcon } from './ThoughtBubbleOutlineIcon';

/**
 * author: Austin Andrews
 * id 2C82E0CA-9872-431C-8739-0EA33825EBF7
 * name thought-bubble-outline
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thought-bubble-outline.svg
 * tags
 */
export const ComicThoughtBubbleOutlineIcon = ThoughtBubbleOutlineIcon;
export default ComicThoughtBubbleOutlineIcon